import SearchIcon from '@mui/icons-material/Search';
import { useAppSelector } from 'app/hooks';
import BoxWrapper from 'blocks/BoxWrapper';
import Button from 'blocks/Button';
import Card from 'blocks/Card';
import Col from 'blocks/Col';
import Row, { RowItem } from 'blocks/Row';
import { Text, Title } from 'blocks/Text';
import CreditCard from 'components/CreditCard';
import EmptyBox from 'components/EmptyBox';
import Loading from 'components/Loading';
import Table from 'components/Table';
import { getDate } from 'helper/date';
import Paths from 'helper/paths';
import { useForm } from 'hooks/useForm';
import WithSidebar from 'layouts/WithSidebar';
import { useEffect, useState } from 'react';
import 'react-circular-progressbar/dist/styles.css';
import { useTranslation } from 'react-i18next';
import { useDispatch } from 'react-redux';
import { Link } from 'react-router-dom';
import { toast } from 'react-toastify';
import { getDashboardService } from 'services/dashboard.service';
import {
  dashboardLoadingState,
  dashboardUserInfoState,
  lastActivitiesState,
  setDashboardData,
  setDashboardError,
  setDashboardLoading,
  tierState,
  toBeExpireTransactionsState,
} from 'store/dashboard/dasboardSlice';
import TierInfoCards from './TierInfoCards';
import ModalInformation from './TierStatus/component/ModalInformation';
import TierStatus from './TierStatus/tierStatus';
import * as S from './dashboard.styles';

const Dashboard = () => {
  const { t } = useTranslation();
  const [openModalInformation, setOpenModalInformation] = useState(false);
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const { inputFields, handleChange } = useForm({
    lastActivity: {
      name: 'lastActivity',
      value: '',
      iconStart: <SearchIcon />,
      type: 'text',
      placeholder: 'Search',
    },
    miles: {
      name: 'miles',
      value: '',
      iconStart: <SearchIcon />,
      type: 'text',
      placeholder: 'Search',
    },
  });

  const userInfo = useAppSelector(dashboardUserInfoState);
  const tiers = useAppSelector(tierState);
  const lastActivities = useAppSelector(lastActivitiesState);
  const toBeExpireTransactions = useAppSelector(toBeExpireTransactionsState);
  const dashboardLoading = useAppSelector(dashboardLoadingState);

  const dispatch = useDispatch();
  useEffect(() => {
    if (!lastActivities || !toBeExpireTransactions || !userInfo || !tiers) {
      getDashboardData();
    }
  }, []);

  useEffect(() => {
    if (!localStorage.getItem('informationuser')) {
      setOpenModalInformation(true);
    }
  }, []);

  const getDashboardData = async () => {
    dispatch(setDashboardLoading());
    getDashboardService()
      .then((res) => {
        dispatch(setDashboardData(res.data));
      })
      .catch((ex) => {
        dispatch(setDashboardError(ex));
      });
  };

  const services = [
    {
      to: Paths.Services.transfer().route,
      title: t('pages.dashboard.sections.sidebar.cards.transferMiles.title'),
      text: t('pages.dashboard.sections.sidebar.cards.transferMiles.text'),
    },
    // {
    //   to: Paths.Services.buyMilage().route,
    //   title: t('pages.dashboard.sections.sidebar.cards.buyMiles.title'),
    //   text: t('pages.dashboard.sections.sidebar.cards.buyMiles.text'),
    // },
    // {
    //   to: Paths.Services.awardTicket().route,
    //   title: t('pages.dashboard.sections.sidebar.cards.freeFlight.title'),
    //   text: t('pages.dashboard.sections.sidebar.cards.freeFlight.text'),
    // },
    {
      to: Paths.Services.discount().route,
      title: t('pages.dashboard.sections.sidebar.cards.discount.title'),
      text: t('pages.dashboard.sections.sidebar.cards.discount.text'),
    },
    {
      to: Paths.Services.convertMilages().route,
      title: t('pages.dashboard.sections.sidebar.cards.convertMilage.title'),
      text: t('pages.dashboard.sections.sidebar.cards.convertMilage.text'),
    },
    {
      to: '/',
      title: t('pages.dashboard.sections.sidebar.IdentificationCode.title'),
      text: t('pages.dashboard.sections.sidebar.IdentificationCode.cards.text'),
      btn: t('pages.dashboard.sections.sidebar.IdentificationCode.cards.btn'),
    },
  ];

  return (
    <WithSidebar>
      <S.Wrapper>
        {dashboardLoading ? (
          <Loading />
        ) : (
          <>
            {userInfo && (
              <BoxWrapper>
                <Card boxShadow="low">
                  <S.RowDash as={Row} flex="1" align="stretch">
                    <S.ParentTier>
                      <TierStatus
                        tierMilage={userInfo.tierMilage}
                        idNumber={userInfo.idNumber}
                        userTierId={userInfo.tierId}
                        typeUser={userInfo.Tier?.type}
                      />
                    </S.ParentTier>
                    <S.Col as={Col}>
                      <S.CreditCard>
                        <CreditCard
                          type={userInfo.Tier?.name}
                          name={userInfo.enFname + ' ' + userInfo.enLname}
                          idNumber={userInfo.idNumber}
                          date={userInfo.tierValidity}
                          color={userInfo.Tier?.color}
                        />
                      </S.CreditCard>
                      <TierInfoCards tierMilage={userInfo.tierMilage} rewardMilage={userInfo.rewardMilage} />
                    </S.Col>
                  </S.RowDash>
                </Card>
              </BoxWrapper>
            )}

            <BoxWrapper>
              <S.RowTable as={Row}>
                <S.RowItemTable as={RowItem}>
                  <BoxWrapper>
                    <Card>
                      <S.CardHead as={Row} justify="space-between">
                        <Title>{t('pages.dashboard.sections.lastActivities.title')}</Title>
                        {/* <Input inputField={inputFields.lastActivity} onChange={handleChange} width={200} /> */}
                      </S.CardHead>
                      {lastActivities?.length ? (
                        <Table
                          name="last-activities"
                          head={[
                            { text: t('pages.dashboard.sections.lastActivities.table.header.activity') },
                            { text: t('pages.dashboard.sections.lastActivities.table.header.reward') },
                            { text: t('pages.dashboard.sections.lastActivities.table.header.tier') },
                            { text: t('pages.dashboard.sections.lastActivities.table.header.expireDate') },
                            { text: t('pages.dashboard.sections.lastActivities.table.header.date') },
                            // { text: '' },
                          ]}
                          rows={lastActivities.map((item) => [
                            { content: item.activity || '---' },
                            { content: item.rewardMilageUsed },
                            { content: item.tierMilageUsed },
                            { content: getDate(item.tierValidity) },
                            { content: getDate(item.createdAt) },
                            // { content: <LaunchIcon />, },
                          ])}
                        />
                      ) : (
                        <EmptyBox title={t('pages.dashboard.sections.lastActivities.emptyText')} />
                      )}
                    </Card>
                  </BoxWrapper>
                  <BoxWrapper>
                    <Card>
                      <S.CardHead as={Row} justify="space-between">
                        <Title>{t('pages.dashboard.sections.milesToExpire.title')}</Title>
                        {/* <Input inputField={inputFields.miles} onChange={handleChange} width={200} /> */}
                      </S.CardHead>
                      {toBeExpireTransactions?.length ? (
                        <Table
                          name="to-be-expired-miles"
                          head={[
                            { text: t('pages.dashboard.sections.milesToExpire.table.header.activity') },
                            { text: t('pages.dashboard.sections.milesToExpire.table.header.reward') },
                            { text: t('pages.dashboard.sections.milesToExpire.table.header.tier') },
                            { text: t('pages.dashboard.sections.milesToExpire.table.header.expireDate') },
                            { text: t('pages.dashboard.sections.milesToExpire.table.header.date') },
                            // { text: '' },
                          ]}
                          rows={toBeExpireTransactions.map((item) => [
                            { content: item.activity || '---' },
                            { content: item.rewardMilageUsed },
                            { content: item.tierMilageUsed },
                            { content: getDate(item.tierValidity) },
                            { content: getDate(item.createdAt) },
                            // { content: <LaunchIcon />, },
                          ])}
                        />
                      ) : (
                        <EmptyBox title={t('pages.dashboard.sections.milesToExpire.emptyText')} />
                      )}
                    </Card>
                  </BoxWrapper>
                </S.RowItemTable>
                <S.Exchange as={RowItem} width={300}>
                  <S.Services as={Col} align="stretch">
                    <S.CardService as={Card}>
                      <S.Services as={Col} align="stretch">
                        <S.CardHead>
                          <Title>{t('pages.dashboard.sections.sidebar.title')}</Title>
                        </S.CardHead>
                        {services.map((item, index) => {
                          return (
                            <S.MenuItem key={index + item.to}>
                              <Link to={item.to} style={{ display: 'flex', alignItems: 'center' }}>
                                <Title>{item.title}</Title>
                                {item.btn && (
                                  <div style={{ display: 'flex', alignItems: 'center' }}>
                                    <p style={{ marginInline: '10px' }}>{`(${userInfo?.refferalCode})`}</p>
                                    <Button
                                      onClick={() => {
                                        navigator.clipboard.writeText(userInfo?.refferalCode);
                                        toast.success(
                                          t('pages.dashboard.sections.sidebar.IdentificationCode.cards.toast-copy')
                                        );
                                      }}
                                    >
                                      {item.btn}
                                    </Button>
                                  </div>
                                )}
                              </Link>
                              <div>
                                <Text size="small">{item.text}</Text>
                              </div>
                            </S.MenuItem>
                          );
                        })}
                        {/* <S.CardHead>
                          <Title>{t('pages.dashboard.sections.sidebar.IdentificationCode.title')}</Title>
                        </S.CardHead>

                        <S.MenuItem>
                          <Title>hdhk</Title>

                          <div>
                            <Text size="small">
                              {t('pages.dashboard.sections.sidebar.IdentificationCode.cards.text')}
                            </Text>
                          </div>
                        </S.MenuItem> */}
                      </S.Services>
                    </S.CardService>
                  </S.Services>
                </S.Exchange>
              </S.RowTable>
            </BoxWrapper>
          </>
        )}
        <ModalInformation
          open={openModalInformation}
          onClose={() => setOpenModalInformation(false)}
          // onSearch={(params: string) => getFlights(0, params)}
          // onClearFilter={() => getFlights(0)}
        />
      </S.Wrapper>
    </WithSidebar>
  );
};

export default Dashboard;
